import React from 'react';

import { getBtnData, getStockByProductName } from '../api/Api';
import { cardClasses } from '@mui/material';
import {
  getFirestore,
  collection,
  addDoc,
  getDoc,
  getDocs,
  updateDoc,
  doc,
  setDoc,
} from 'firebase/firestore';
import { db, auth } from '../config-firebase/firebase.js';
import { signInAnonymously } from 'firebase/auth';
import * as XLSX from 'xlsx';

export const isEmptyObject = (obj) => {
  if (!obj || obj.firstLabel === '' || obj.firstLabel === undefined) {
    return true;
  } else {
    return false;
  }
};

export async function checkUnavaiableRawMaterial(id) {
  // 1) BUSCA DIRETA DO OBJETO NO FIRESTORE PELO ID

  const docRef = doc(db, 'stock', id);
  const docSnap = await getDoc(docRef);

  if (!docSnap.exists()) return;

  const stock = { id: docSnap.id, ...docSnap.data() };
  const { totalVolume, disabledDish, idProduct, product } = stock;

  //
  // Normaliza o nome da matéria prima do estoque
  //
  const normalizedProduct = product
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  //
  // 2) BUSCA TODOS OS PRATOS (collection 'item')
  //
  const itemsSnapshot = await getDocs(collection(db, 'item'));

  //
  // 3) Função auxiliar que normaliza nome de ingrediente
  //
  const normalize = (str) =>
    str
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  //
  // 4) Função que processa um array de ingredientes
  //
  let foundIngredient = false;
  let recipeChanged = false;
  const processIngredientsArray = (arr, isUnavailable) => {
    if (!Array.isArray(arr)) return;

    arr.forEach((ing) => {
      if (!ing || typeof ing.name !== 'string') return;
      const normalizedIngName = normalize(ing.name);

      // Se é a matéria-prima alvo da função
      if (normalizedIngName === normalizedProduct) {
        if (ing.unavailableRawMaterial !== isUnavailable) {
          ing.unavailableRawMaterial = isUnavailable; // true ou false
          recipeChanged = true;
        }
        foundIngredient = true;
      }
    });
  };

  //
  // 5) Para cada prato (item)
  //

  for (const dishSnap of itemsSnapshot.docs) {
    const data = dishSnap.data();
    foundIngredient = false;
    recipeChanged = false;

    const recipe = data?.recipe?.FinalingridientsList;
    if (!recipe) continue;

    // Clone seguro
    let updatedRecipe = structuredClone(recipe);

    //
    // VERIFICAÇÃO DE INDISPONIBILIDADE
    //
    const isUnavailable = Number(disabledDish) >= Number(totalVolume);

    //
    // 6) Cenário 1 → Recipe é UM ARRAY
    //
    if (Array.isArray(updatedRecipe)) {
      processIngredientsArray(updatedRecipe, isUnavailable);
    }

    //
    // 7) Cenário 2 → Recipe é OBJETO com múltiplos arrays
    else if (typeof updatedRecipe === 'object' && updatedRecipe !== null) {
      const labels = data.CustomizedPrice;
      
      // Tentar chaves fixas (Novo Padrão)
      processIngredientsArray(updatedRecipe.firstPrice, isUnavailable);
      processIngredientsArray(updatedRecipe.secondPrice, isUnavailable);
      processIngredientsArray(updatedRecipe.thirdPrice, isUnavailable);

      // Tentar chaves por labels (Padrão Antigo / Compatibilidade)
      if (labels) {
        processIngredientsArray(updatedRecipe[labels.firstLabel], isUnavailable);
        processIngredientsArray(updatedRecipe[labels.secondLabel], isUnavailable);
        processIngredientsArray(updatedRecipe[labels.thirdLabel], isUnavailable);
      }
    }
    //Aqui temos o problema a ser pensado depois de que o isUnavailable pode estar em uma das receitas desse grupo de 3 arrays
    //
    // 8) Ajuste da flag LOW AMOUNT no prato
    //
    const originalLowAmount = !!data.lowAmountRawMaterial;
    let nextLowAmount = false;

    if (isUnavailable && foundIngredient) {
      // Se a matéria-prima está indisponível → prato fica indisponível
      nextLowAmount = true;
    } else {
      //
      // Cenário inverso:
      // totalVolume > disabledDish → verificar se ainda existe ALGUM ingrediente indisponível
      //

      // Função corrigida para ignorar grupos que não usam o ingrediente
      const checkStillUnavailable = (arr) => {
        if (!Array.isArray(arr)) return null; // grupo não relevante

        const found = arr.some((ing) => ing?.unavailableRawMaterial === true);

        return found ? true : null; // true = indisponível; null = irrelevante
      };

      if (Array.isArray(updatedRecipe)) {
        // Receita de array único
        nextLowAmount = checkStillUnavailable(updatedRecipe) === true;
      } else {
        // Receita com múltiplos arrays
        const labels = data.CustomizedPrice;

        const results = [
          checkStillUnavailable(updatedRecipe.firstPrice),
          checkStillUnavailable(updatedRecipe.secondPrice),
          checkStillUnavailable(updatedRecipe.thirdPrice),
        ];

        if (labels) {
          results.push(checkStillUnavailable(updatedRecipe[labels.firstLabel]));
          results.push(checkStillUnavailable(updatedRecipe[labels.secondLabel]));
          results.push(checkStillUnavailable(updatedRecipe[labels.thirdLabel]));
        }

        // Se QUALQUER grupo retornar true → prato fora do cardápio
        nextLowAmount = results.includes(true);
      }
    }

    if (originalLowAmount !== nextLowAmount) {
      data.lowAmountRawMaterial = nextLowAmount;
      recipeChanged = true;
    }

    if (recipeChanged) {
      console.log(
        `[OPTIMIZATION] Prato ${data.title} atualizado no Firestore: lowAmountRawMaterial = ${data.lowAmountRawMaterial}`,
      );

      // --- SALVAR AS ALTERAÇÕES NO FIRESTORE ---
      const dishRef = doc(db, 'item', dishSnap.id);

      // monta o payload atualizado
      // --- MONTAR PAYLOAD CONFORME O TIPO DE RECIPE ---
      let updatedPayload;

      if (Array.isArray(recipe)) {
        // 1) Recipe simples (um único array)
        updatedPayload = {
          ...data,
          recipe: {
            FinalingridientsList: updatedRecipe,
          },
        };
      } else {
        // 2) Recipe com 3 arrays dentro de um objeto
        updatedPayload = {
          ...data,
          recipe: {
            FinalingridientsList: updatedRecipe, // updatedRecipe já é o objeto com 3 arrays
          },
          CustomizedPrice: data.CustomizedPrice, // mantém o mapeamento dos 3 labels
        };
      }

      // salva no firestore
      await updateDoc(dishRef, updatedPayload);
    }
  }
  return false;
}

// helpers/alertMinimumAmount.js

export const alertMinimunAmount = (product, volume, minimum, cost) => {
  // Caso especial: estoque zerado intencionalmente (sem estoque e sem volume mínimo)
  if (Number(volume) === 0 && Number(minimum) === 0) {
    return { status: true, message: '' };
  }

  if (volume < minimum) {
    return {
      status: false,
      message: `⚠️ O produto ${product} foi recusado porque o volume (${volume}) está menor que o mínimo (${minimum})`,
    };
  }

  if (volume === 0) {
    return {
      status: false,
      message: ` O produto ${product} foi recusado porque o volume está igual a 0`,
    };
  }

  if (minimum === undefined) {
    console.log(`⚠️`);
    return {
      status: false,
      message: ` O produto ${product} foi recusado porque o mínimo está indefinido`,
    };
  }

  if (isNaN(cost)) {
    return {
      status: false,
      message: `O produto ${product} foi recusado porque o custo não é um número`,
    };
  }

  if (cost === undefined) {
    return {
      status: false,
      message: `O produto ${product} foi recusado porque o custo está indefinido`,
    };
  }

  if (cost <= 0) {
    return {
      status: false,
      message: `O produto ${product} foi recusado porque o custo (${cost}) é menor ou igual a 0`,
    };
  }

  // ✅ Se passou em todas as verificações:
  return { status: true, message: '' };
};

export const exportToExcel = (ObjList, fileName = 'data.xlsx') => {
  if (!ObjList.length) {
    alert('Nenhum cliente para exportar!');
    return;
  }

  try {
    // Mantém apenas chaves com valores primitivos (string, number, boolean)
    const simplifiedList = ObjList.map((obj) => {
      const flatObj = {};
      for (const key in obj) {
        const value = obj[key];
        if (
          typeof value === 'string' ||
          typeof value === 'number' ||
          typeof value === 'boolean'
        ) {
          flatObj[key] = value;
        }
      }
      return flatObj;
    });

    const worksheet = XLSX.utils.json_to_sheet(simplifiedList);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');
    XLSX.writeFile(workbook, fileName);

    console.log('Arquivo Excel gerado com sucesso!');
    alert('Arquivo Excel foi baixado com sucesso!');
  } catch (err) {
    console.error('Erro ao exportar Excel:', err);
    alert('Erro ao gerar o arquivo Excel');
  }
};

export function firstNameClient(nameCustomer) {
  if (nameCustomer) {
    let firstName = nameCustomer.split(' ')[0];
    return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
  } else {
    return '';
  }
}

export function getFirstFourLetters(inputString, max) {
  return inputString ? inputString.slice(0, max) : '';
}

export async function CheckUser(check, isTotenParam, packageTier) {
  const isToten = isTotenParam || localStorage.getItem('isToten') === 'true';

  if (isToten) {
    if (!localStorage.hasOwnProperty(check)) {
      const defaultNoCustomer = {
        name: 'anonimo',
        phone: '777',
        birthday: '77',
        email: 'anonimo@anonimo.com',
        request: [],
      };
      const currentUid = auth.currentUser?.uid || `legacy_anon_${Date.now()}`;
      const updatedUser = {
        id: currentUid,
        name: 'anonimo',
        migratedToAuth: false,
      };
      localStorage.setItem(check, JSON.stringify(updatedUser));
      try {
        const docRef = doc(db, 'user', currentUid);
        getDoc(docRef).then((snap) => {
          if (!snap.exists()) {
            setDoc(docRef, defaultNoCustomer).catch((err) =>
              console.warn('Erro ao criar doc anônimo no CheckUser:', err),
            );
          }
        }).catch(() => {});
      } catch (e) {}
    }
    return '/new-layout';
  }

  if (localStorage.hasOwnProperty(check)) {
    const userMenu = JSON.parse(localStorage.getItem(check));
    if (!userMenu || !userMenu.id) {
      localStorage.removeItem(check);
      return Number(packageTier) === 1 ? '/create-customer' : '/admin/check-customer-nolog';
    }

    try {
      const userDocRef = doc(db, 'user', userMenu.id);
      const userSnap = await getDoc(userDocRef);

      if (userSnap.exists() && userSnap.data()?.name) {
        if (localStorage.getItem('pdv') === 'true') {
          return '/admin/requestlist';
        } else {
          return '/';
        }
      } else {
        localStorage.removeItem(check);
        return Number(packageTier) === 1 ? '/create-customer' : '/admin/check-customer-nolog';
      }
    } catch (error) {
      console.warn('Erro ao verificar usuário no Firestore (mantendo sessão local):', error);
      if (localStorage.getItem('pdv') === 'true') {
        return '/admin/requestlist';
      } else {
        return '/';
      }
    }
  } else {
    if (Number(packageTier) === 1) {
      return '/create-customer';
    }
    return '/admin/check-customer-nolog';
  }
}


export const requestSorter = (ObjList, direction) => {
  const sortedList = [...ObjList].map((item) => ({
    ...item,
    countRequest: Number(item.countRequest) || 0, // força número ou 0
  }));

  sortedList.sort((a, b) => {
    return direction
      ? b.countRequest - a.countRequest
      : a.countRequest - b.countRequest;
  });

  return sortedList;
};

export const isOrderFullyFinished = (item) => {
  if (!item.request || item.request.length === 0) return false;
  // Um pedido está totalmente finalizado se todos os pratos estão PRONTOS e ENTREGUES pela cozinha
  return item.request.every((req) => req.pronto && req.entregue);
};

export const logToAnounimousInToten = (setNameClient) => {
  const noCustomer = {
    name: 'anonimo',
    phone: '777',
    birthday: '77',
    email: 'anonimo@anonimo.com',
  };
  if (localStorage.hasOwnProperty('isToten')) {
    if (localStorage.hasOwnProperty('userMenu')) {
      const currentUserNew = JSON.parse(localStorage.getItem('userMenu'));
      if (currentUserNew) {
        setNameClient(currentUserNew.name);
        if (typeof global !== 'undefined' && global.setId) {
          global.setId(currentUserNew.name);
        }
      }
    } else {
      const executeTotenAuth = async () => {
        try {
          let currentUser = auth.currentUser;
          if (!currentUser) {
            const userCredential = await signInAnonymously(auth);
            currentUser = userCredential.user;
          }
          const uid = currentUser.uid;
          await setDoc(doc(db, 'user', uid), noCustomer);
          if (typeof global !== 'undefined' && global.setId) {
            global.setId(uid);
          }
          console.log('Toten document written with UID: ', uid);
          setNameClient('anonimo');
          localStorage.setItem(
            'userMenu',
            JSON.stringify({ id: uid, name: 'anonimo', migratedToAuth: true }),
          );
        } catch (e) {
          console.error("Erro no login anônimo Toten no Helpers:", e);
        }
      };
      executeTotenAuth();
    }
  }
};

export async function calculateItemCost(item) {
  const results = {};

  const processIngredientList = async (ingredientList) => {
    let totalCost = 0;
    const invalidIngredients = [];
    console.log('Ingredient List:', ingredientList);
    for (const ingredient of ingredientList) {
      const stock = await getStockByProductName(ingredient.name);
      if (stock && stock.totalVolume && stock.totalCost) {
        const costPerUnit = stock.totalCost / stock.totalVolume;

        const amount = parseFloat(ingredient.amount.replace(',', '.')); // garante conversão correta

        totalCost += amount * costPerUnit;
      } else {
        invalidIngredients.push(ingredient.name);
        console.warn(
          `Stock not found or invalid for ingredient: ${ingredient.name}`,
        );
        if (invalidIngredients.length > 0) {
          alert(
            `O valor do custo não está correto porque os seguintes ingredientes não têm valores válidos: ${invalidIngredients.join(
              ', ',
            )}. O cálculo foi feito apenas com os ingredientes válidos.`,
          );
        }
      }
    }

    // Arredonda para 2 casas decimais
    totalCost = Math.round((totalCost + Number.EPSILON) * 100) / 100;

    return Number(totalCost.toFixed(2));
  };

  // Caso 1: FinalingredientList é um array
  if (Array.isArray(item?.FinalingridientsList)) {
    const cost = await processIngredientList(item?.FinalingridientsList);
    return { default: cost }; // retorna com uma key padrão
  }

  // Caso 2: FinalingredientList é um objeto com arrays
  if (
    typeof item?.FinalingridientsList === 'object' &&
    item?.FinalingridientsList !== null
  ) {
    const sizes = item.FinalingridientsList;

    for (const [sizeName, ingredientList] of Object.entries(sizes)) {
      const cost = await processIngredientList(ingredientList);
      results[sizeName] = Number(cost.toFixed(2));
    }

    return results;
  }

  return null;
}
//There is no need to export this function, it is used only in the PriceAndExpenseBuilder.js
//te
